import { fetchStore } from 'api/Store/actions'
import { selectStore } from 'data/selectors'
import { selectRequestParams } from 'data/selectors'
import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getStoreById } from 'revenue/RevenueDetails/selectors'
import type { State } from 'store/types'
import { emptyObject } from 'utils'

import SearchDetails from './SearchDetails'
import * as selectors from './selectors'

function SearchDetailsContainer() {
  const dispatch = useDispatch()
  const { storeId } = useSelector(selectors.getDetails)
  const store = useSelector((state: State) => getStoreById(state, storeId))
  const { data, isLoading } = useSelector(selectStore({ storeId })) as any
  const requestParams = useSelector(selectRequestParams)
  const getDetails = useCallback(() => {
    if (!data?.details) return emptyObject

    return {
      ...data.details,
      traffic: data.storeReplenishment,
      results: data.results,
      storeReplenishment: data.storeReplenishment,
    }
  }, [data])
  const details = getDetails()

  useEffect(() => {
    dispatch(
      fetchStore({
        ...requestParams,
        storeId,
      }),
    )
  }, [dispatch, storeId, requestParams])

  return <SearchDetails store={store} detailsFetching={isLoading} details={details || emptyObject} />
}

export default SearchDetailsContainer
